export default __webpack_public_path__ + "static/CHILLPEPE-c1c10c7bab4e26f8071df653856ba998.png";